export default [
    {
        path: '/services/family',
        name: 'services.family',
        component: () => import('@/views/dashboard/family/FamilySummary.vue'),
        meta: { 
            service: 'family',
            smallMenu: true,
            active: 'family'
        },
    },

    // LEADS INDEX
    {
        path: '/services/family/leads',
        name: 'services.family.leads',
        component: () => import('@/views/dashboard/LeadsIndex.vue'),
        meta: { 
            service: 'family',
            type: 'lead',
            smallMenu: true,
            active: 'family'
        },
    },
    // LEADS SINGLE
    {
        path: '/services/family/leads/view/:reference?',
        name: 'services.family.leads.view',
        component: () => import('@/views/dashboard/LeadSingle.vue'),
        meta: {
            service: 'family',
            type: 'lead',
            smallMenu: true,
            active: 'family',
        }
    },

    // QUOTES INDEX
    {
        path: '/services/family/quotes',
        name: 'services.family.quotes',
        component: () => import('@/views/dashboard/family/FamilyQuotesIndex.vue'),
        meta: { 
            service: 'family',
            type: 'quote',
            smallMenu: true,
            active: 'family'
        },
    },
    // QUOTES SINGLE
    {
        path: '/services/family/quotes/view/:reference?',
        component: () => import('@/views/layouts/SingleQuoteWrapper.vue'),
        props: true,
        meta: { 
            service: 'family',
            type: 'quote',
            smallMenu: true,
            active: 'family'
        },
        children: [
            {
                path: '',
                name: 'services.family.quote.view',
                component: () => import('@/components/services/QuoteDetailsTab.vue'),
                props: true,
            },
            {
                path: 'summary',
                name: 'services.family.quote.view.summary',
                component: () => import('@/components/dashboard/family/FamilyQuoteSummary.vue'),
                props: true,
            },
            {
                path: 'fees',
                name: 'services.family.quote.view.fees',
                component: () => import('@/components/dashboard/misc/QuoteMatterFeesTab.vue'),
                props: true,
            },
            {
                path: 'activity',
                name: 'services.family.quote.view.activity',
                component: () => import('@/components/dashboard/misc/QuoteMatterActivityTab.vue'),
                props: true,
            },
        ],
    },

    // // MATTERS INDEX
    // {
    //     path: '/services/family/matters',
    //     name: 'services.family.matters',
    //     component: () => import('@/views/dashboard/family/FamilyMattersIndex.vue'),
    //     meta: { 
    //         service: 'family',
    //         type: 'matter',
    //         smallMenu: true,
    //         active: 'family'
    //     },
    // },
]